/**
 * @file     ctaState.ts
 * @purpose  Shared CTA copy + destination for the Deal Finder funnel. When a
 *           logged-in user has already submitted, every "Start My Search"
 *           style CTA should send them to their dashboard with "View My
 *           Matches" copy instead of restarting the funnel.
 */

export const DEAL_FINDER_SUBMITTED_DESTINATION = '/dashboard';
export const DEAL_FINDER_SUBMITTED_LABEL = 'View dashboard';

export type DealFinderCtaState = {
  hasSubmitted: boolean;
  href: string;
  label: string;
};

export const DEAL_FINDER_SUBMITTED_LABEL_KEY = 'nav.items.viewMyMatches';

/** Path is treated as a deal-finder funnel entry that should be remapped. */
export function isDealFinderFunnelPath(path: string): boolean {
  return path === '/deal-finder' || path.startsWith('/deal-finder/') || path.startsWith('/deal-finder?');
}

export function resolveDealFinderCtaState(
  hasSubmitted: boolean,
  fallback: { href: string; label: string },
): DealFinderCtaState {
  if (hasSubmitted) {
    return {
      hasSubmitted: true,
      href: DEAL_FINDER_SUBMITTED_DESTINATION,
      label: DEAL_FINDER_SUBMITTED_LABEL,
    };
  }
  return { hasSubmitted: false, ...fallback };
}
